import Section from './_Section'
import ButtonEl from '../helpers/ctas/Button'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'

function CalloutCard(props) {
  const sectionGradient = !['None', 'ContentArea'].includes(props.backgroundGradientType)
  const contentGradient = ['ContentArea'].includes(props.backgroundGradientType)
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  // Check if component has any background styling
  const hasBackground =
    props.backgroundColor ||
    props.desktopBackgroundImage ||
    props.mobileBackgroundImage ||
    (props.gradientType && props.gradientType !== 'None')

  // Handle content alignment (left/center/right) from Component Configuration
  const alignment = props.contentAlignment?.toLowerCase() || 'center'
  const flexAlignClass =
    alignment === 'center' ? 'justify-center' : alignment === 'right' ? 'justify-end' : 'justify-start'
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'

  return (
    <Section
      type="calloutCard"
      outerClass={componentPadding}
      sectionTitle={false}
      innerClass={`flex ${flexAlignClass} !max-w-7xl`}
      {...props}
    >
      <div
        className={`
        flex flex-row items-center justify-between w-full
        md:flex-row md:items-center md:gap-8
        max-md:flex-col max-md:items-start max-md:gap-6
        px-8 py-6
        ${hasBackground ? '' : 'border border-(--color-border-primary) rounded-lg max-xl:mx-4 max-xl:w-[calc(100%-2rem)]'}
      `}
      >
        {(props.title || props.description) && (
          <TitleBlock
            headingClass={`
              w-full text-left text-5xl font-bold
              lg:flex-1 lg:max-w-none
              max-md:w-full
            `}
            descriptionClass={`text-lg font-normal`}
            {...props}
          />
        )}
        {props.ctaLink && props.ctaLink.length != 0 && (
          <div
            className={`
            flex flex-wrap items-center gap-4
            lg:flex-shrink-0 lg:justify-end
            md:flex-shrink-0 md:justify-end
            max-md:w-full max-md:justify-start
            ${props.title || props.description ? '' : 'w-full justify-end'}
          `}
          >
            {props.ctaLink.map((ctaLinkItem, i) => {
              let content = ctaLinkItem.link?.name
              const url = ctaLinkItem.link?.url
              return (
                <div key={i} className={`flex-shrink-0 max-md:w-full ${url?.startsWith('tel:') ? 'tel' : ''}`}>
                  <ButtonEl
                    link={ctaLinkItem.link}
                    theme={ctaLinkItem.linkType.toLowerCase()}
                    icon={ctaLinkItem.linkIconClass}
                    position={ctaLinkItem.linkPosition}
                    className="max-md:w-full max-md:justify-center"
                  >
                    {content}
                  </ButtonEl>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Section>
  )
}

export default CalloutCard
